import React, { useRef, useState, useEffect } from 'react'
import Cropper from 'react-cropper'
import { useTranslation } from 'react-i18next'

import { getFileDataURL } from 'utils/file'

import 'cropperjs/dist/cropper.css'

import Modal from 'components/Modal/Modal'
import LoaderEllipsis from 'components/LoaderEllipsis/LoaderEllipsis'

import styles from './ImageCropper.module.scss'

const ImageCropper = ({ url, file, data, onAccept, onCancel }) => {
    const { t } = useTranslation()
    const [src, setSrc] = useState(null)
    const cropperRef = useRef(null)

    useEffect(() => {
        if (url) {
            setSrc(url)
            return
        }

        if (data) setSrc(data)
        if (file) {
            getFileDataURL(file)
                .then(_data => setSrc(_data))
                .catch(err => console.error(err))
        }
    }, [])

    const onCrop = () => {
        const cropper = cropperRef.current?.cropper
        if (!cropper) return
        const fileName = file ? file.name : new Date().toUTCString()
        cropper.getCroppedCanvas().toBlob(blob => onAccept(blob, fileName), file ? file.type : 'image/png')
    }

    return (
        <Modal onClose={onCancel}>
            <div className={styles.imageCropper}>
                {!!src ? (
                    <>
                        <Cropper
                            ref={cropperRef}
                            src={src}
                            style={{ height: 400, width: '100%' }}
                            viewMode={1}
                            minCropBoxHeight={40}
                            minCropBoxWidth={40}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            checkOrientation={false}
                            guides={true}
                            zoomable={false}
                        />
                        <div className={styles.actions}>
                            <button className="button" data-size="md" onClick={onCancel} data-variant="secondary">
                                {t('Cancel')}
                            </button>
                            <button className="button" data-size="md" onClick={onCrop} data-variant="primary">
                                {t('Save')}
                            </button>
                        </div>
                    </>
                ) : (
                    <LoaderEllipsis />
                )}
            </div>
        </Modal>
    )
}

export default ImageCropper
